import {Directive, ElementRef, OnInit, Input, forwardRef, EventEmitter} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {isEmpty, isUndefined, isNumber, groupBy, isNil, includes, isString} from 'lodash';
import {AutocompleteService} from './autocomplete.service';
import {ModelListener} from '../model-listener';
const $ = require("jquery");
require("typeahead.js");

const PROVIDER: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => AutoComplete),
    multi: true
};

const navigationKeyCodes = [37, 38, 39, 40, 35, 36];

@Directive({
    selector: '[bs-autocomplete]',
    providers: [PROVIDER, AutocompleteService]
})
export class AutoComplete extends ModelListener implements ControlValueAccessor, OnInit {

    onChange: EventEmitter<any> = new EventEmitter<any>();
    onTouchedCallback: EventEmitter<any> = new EventEmitter<any>();

    @Input('ac-source') source: Array<any>;
    @Input('ac-key') keyParam: string;
    @Input('ac-value') valueParam: string;
    @Input('items-limit') itemsLimit: number = 5;
    @Input('min-query-length') minQueryLength: number = 1;
    @Input('menu-class') menuClass: string = 'tt-menu';

    private _keysMap: Object;
    private _valuesMap: Object;

    constructor(private el: ElementRef,
                private service: AutocompleteService) {
        super();
    }

    valueFormatter(newValue) {
        if (!isEmpty(newValue)) {
            let item: any = this._keysMap[newValue];
            if (item && item !== null && item[0] && item[0] !== null) {
                return item[0][this.valueParam];
            }
        }

        return newValue;
    }

    keyFormatter(newKey: number|String) {
        let valuesMap;
        if (isNumber(newKey)) {
            valuesMap = groupBy(this.source, this.keyParam);
        }
        if (isString(newKey) && !isEmpty(newKey)) {
            valuesMap = groupBy(this.source, this.valueParam);
        }
        if (!isNil(newKey) && isString(newKey) && !isEmpty(newKey)) {
            let item: any = valuesMap[newKey];
            if (item && item !== null && item[0] && item[0] !== null) {
                return item[0][this.keyParam];
            }
        } else {
            return isString(newKey) ? null : newKey;
        }

    }

    writeValue(obj) {
        super.writeValue(obj);
        let key = this.keyFormatter(obj);
        if (!isNil(key)) {
            let valuesMap = groupBy(this.source, this.keyParam);
            let item: any = valuesMap[key];
            if (!isUndefined(item)) {
                $(this.el.nativeElement).typeahead('val', item[0][this.valueParam]);
                return;
            }
        }

        $(this.el.nativeElement).typeahead('val', '');
    }

    ngOnInit() {
        //todo andrey resolve typescript lazy loading problem
        //lazy loading outer library
        //noinspection TypeScriptValidateTypes,TypeScriptUnresolvedFunction
        $(this.el.nativeElement).typeahead({
                classNames: {
                    menu: this.menuClass
                },
                hint: false,
                highlight: true,
                minLength: this.minQueryLength,
            },
            {
                source: this.service.buildSuggestionEngine(
                    () => this.source,
                    item => item[this.valueParam],
                    source => {
                        this._keysMap = groupBy(source, this.keyParam);
                        this._valuesMap = groupBy(source, this.valueParam);
                    }),
                limit: this.itemsLimit
            })
            .on('typeahead:select', (event) => {
                this.writeValue(event.target.value);
            })
            .on('typeahead:change', (event) => {
                if (!isNil(this._valuesMap) && isNil(this._valuesMap[event.target.value])) {
                    this.writeValue('');
                }
            })
            .on('keyup', (event) => {
                if (!includes(navigationKeyCodes, event.keyCode)) {
                    if (!isNil(this._valuesMap) && !isNil(this._valuesMap[event.target.value])) {
                        this.writeValue(event.target.value);
                    }
                }
            }).closest('.twitter-typeahead').css('display', 'block');
        $(this.el.nativeElement).on("blur", (event) => {
            this.onTouchedCallback.emit();
            if (isEmpty(event.target.value)) {
                this.writeValue('');
            }
        });

    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/autocomplete/autocomplete.directive.ts